import type { FaireProductEntity } from "../../entity_types/product";

export const p_skc6gt2ajn: FaireProductEntity = {
  token: "p_skc6gt2ajn",
  type: "product",
  name: "Marbled Cube Putty Filled Squishy - 12 Pcs",
  brandToken: "b_1e67dn411w",
  brandName: "Cap Zone",
  imageUrl:
    "https://cdn.faire.com/fastly/4bf634a0c336758ac6a19e7d2ae1910489b1eb193f3fc6bcc0cd300cb275291c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6025843d26d11625fb81a928a45f3353717d611eb243538cd4bccbd4caa0b59a.jpeg",
    "https://cdn.faire.com/fastly/44c423586e1428fab3f7c9203998576a2b8154573854fb8523edbf54a7058d0a.jpeg",
    "https://cdn.faire.com/fastly/1c156da606076d5d6e150f8dd0e229e9215ccad66b4c13de3fdfb9198f931a79.jpeg",
    "https://cdn.faire.com/fastly/bcaa40114cbfa92c029b6f88e0682c84fbddffedb33da987dfddaec5c2051823.jpeg",
    "https://cdn.faire.com/fastly/869985dbabe19b0f1f4e2c14e45ba8b8c3849a607fcb30f3ca1f27b40f235bce.jpeg",
  ],
  priceDollars: 3.75,
  description:
    'DISCLAIMER: Please note that due to continuous manufacturing updates and natural variations between production batches, the exact packaging design, item colorways, and print patterns may vary slightly from the images shown. Pictures are for reference only. \n\nThick Putty Slime Filled Square Stress Ball with Marble Swirl Pattern and Slow Rise\n-Squishy Dimensions: 2" * 2" * 2"\n-Individual Box Dimensions: Appx. 2.35" * 2.35" * 2.1"\n-Display Box Dimensions: 7.75" * 5" * 4.5"\n-Assorted Color (12 - Random Assortments Per Color, May Vary)\n-100% TPR Rubber\n-CA Prop 65 Advisory\n-Packaging Details: Individually packed in packaging box, then packaged as a whole in illustrated cardboard display box. \n\nExperience the ultimate sensory satisfaction with this unique cube-shaped squeeze toy. Unlike standard air-filled squishies, this fidget toy is filled with thick, resistance-heavy putty slime that holds its shape when squeezed and stretched. The exterior features a mesmerizing as it is tactile.',
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:49.083Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
